import { Group } from '@mantine/core';
import {
  IconCalendarEvent,
  IconDotsCircleHorizontal,
  IconFiles,
  IconLayoutSidebarRightCollapse,
  IconX,
} from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useNavigationItem } from '../../../Organismns/Navigation/NavigationItemHook';
import { EventParticipationsContext } from '../../../Service/Context/EventParticipationContextV2';
import ActionIconWithText from './ActionIconWithText';
import InboxIconWithIndicator from './InboxIconWithIndicator';

interface HandlersProps {
  openNavBar: () => void;
  toggleAsideBar: () => void;
  asideBarOpen: boolean;
}

const EventDetailsFooter: FC<HandlersProps> = ({ openNavBar, toggleAsideBar, asideBarOpen }) => {
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const { unreadMessagesProps } = useContext(EventParticipationsContext);
  const { unreadCount } = unreadMessagesProps;

  // eslint-disable-next-line no-underscore-dangle
  const _navigate = (pathname: string) => {
    if (asideBarOpen) {
      toggleAsideBar();
    }
    navigate(pathname);
  };

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText label="Alle" onClick={openNavBar}>
        <IconLayoutSidebarRightCollapse />
      </ActionIconWithText>
      <ActionIconWithText
        label="Details"
        active={useNavigationItem(`/events/${eventId}/details`)}
        onClick={() => _navigate(`/events/${eventId}/details`)}
      >
        <IconCalendarEvent />
      </ActionIconWithText>
      <ActionIconWithText
        label="Dateien"
        active={useNavigationItem(`/events/${eventId}/documents`)}
        onClick={() => _navigate(`/events/${eventId}/documents`)}
      >
        <IconFiles />
      </ActionIconWithText>
      <ActionIconWithText
        label="Mails"
        active={useNavigationItem(`/events/${eventId}/emails`)}
        onClick={() => _navigate(`/events/${eventId}/emails/inbox`)}
      >
        <InboxIconWithIndicator unreadCount={unreadCount} />
      </ActionIconWithText>
      <ActionIconWithText label={asideBarOpen ? '' : 'Mehr'} onClick={toggleAsideBar}>
        {asideBarOpen ? <IconX /> : <IconDotsCircleHorizontal />}
      </ActionIconWithText>
    </Group>
  );
};

export default EventDetailsFooter;
